"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  Newsroom: () => Newsroom,
  Provider: () => Provider,
  createApi: () => createApi
});
module.exports = __toCommonJS(index_exports);

// src/component/index.ts
var getComponent = (client, provider) => async (id, options) => {
  return await client.get(`${provider}/components/${id}`, options).json();
};
var createComponent = (client, provider) => async (data, options) => {
  return await client.post(`${provider}/components`, { json: data, ...options }).json();
};
var updateComponent = (client, provider) => async (id, data, options) => {
  return await client.patch(`${provider}/components/${id}`, { json: data, ...options }).json();
};
var getSharedComponents = (client, provider) => async (options) => {
  return await client.get(`${provider}/components/shared`, options).json();
};
var getComponentSettings = (client, provider) => async (options) => {
  return await client.get(`${provider}/components/settings`, options).json();
};
var createComponentApi = (client, provider) => {
  return {
    getComponent: getComponent(client, provider),
    createComponent: createComponent(client, provider),
    updateComponent: updateComponent(client, provider),
    getSharedComponents: getSharedComponents(client, provider),
    getComponentSettings: getComponentSettings(client, provider)
  };
};

// src/editor.ts
var getEditors = (client, provider) => async (options) => {
  return await client.get(`${provider}/editors`, options).json();
};
var getEditor = (client, provider) => async (id, options) => {
  return await client.get(`${provider}/editors/${id}`, options).json();
};
var createEditor = (client, provider) => async (data, options) => {
  return await client.post(`${provider}/editors`, { json: data, ...options }).json();
};
var updateEditor = (client, provider) => async (id, data, options) => {
  return await client.patch(`${provider}/editors/${id}`, { json: data, ...options }).json();
};
var createEditorApi = (client, provider) => {
  return {
    getEditors: getEditors(client, provider),
    getEditor: getEditor(client, provider),
    createEditor: createEditor(client, provider),
    updateEditor: updateEditor(client, provider)
  };
};

// src/user.ts
var getMe = (client) => async (options) => {
  return await client.get("users/me", options).json();
};
var createUserApi = (client) => {
  return {
    getMe: getMe(client)
  };
};

// src/image.ts
var createImage = (client, provider) => async (data, options) => {
  return await client.post(`${provider}/images`, { body: data, ...options }).json();
};
var createImageApi = (client, provider) => {
  return {
    createImage: createImage(client, provider)
  };
};

// src/cnp_story.ts
var getStory = (client, provider) => async (id, options) => {
  return await client.get(`${provider}/stories/${id}`, options).json();
};
var searchStories = (client, provider) => async (query, options) => {
  return await client.get(`${provider}/stories/${query}`, options).json();
};
var createStoryApi = (client, provider) => {
  return {
    getStory: getStory(client, provider),
    searchStories: searchStories(client, provider)
  };
};

// src/utils.ts
var clearObject = (object) => {
  return Object.keys(object).reduce((acc, curr) => {
    if (typeof object[curr] === "undefined") {
      return acc;
    }
    return { ...acc, [curr]: object[curr] };
  }, {});
};

// src/cnp_tag.ts
var getTag = (client, provider) => async (id, options) => {
  return await client.get(`${provider}/tags/${id}`, options).json();
};
var searchTags = (client, provider) => async (query, options) => {
  return await client.get(`${provider}/tags/search/${query}`, options).json();
};
var getProfiles = (client, provider) => async (categoryId, options) => {
  return await client.get(`${provider}/tags/profiles`, {
    searchParams: clearObject({ categoryId }),
    ...options
  }).json();
};
var getEnrichments = (client, provider) => async (options) => {
  return await client.get(`${provider}/tags/enrichments`, options).json();
};
var getEnrichment = (client, provider) => async (id, options) => {
  return await client.get(`${provider}/tags/enrichments/${id}`, options).json();
};
var createEnrichment = (client, provider) => async (data, options) => {
  return await client.post(`${provider}/tags/enrichments`, { json: data, ...options }).json();
};
var updateEnrichment = (client, provider) => async (id, data, options) => {
  return await client.patch(`${provider}/tags/enrichments/${id}`, { json: data, ...options }).json();
};
var createTagApi = (client, provider) => {
  return {
    getTag: getTag(client, provider),
    searchTags: searchTags(client, provider),
    getProfiles: getProfiles(client, provider),
    getEnrichments: getEnrichments(client, provider),
    getEnrichment: getEnrichment(client, provider),
    createEnrichment: createEnrichment(client, provider),
    updateEnrichment: updateEnrichment(client, provider)
  };
};

// src/page.ts
var getPage = (client, provider) => async (id) => {
  return await client.get(`/${provider}/pages/${id}`).json();
};
var createPage = (client, provider) => async (data, options) => {
  return await client.post(`${provider}/pages`, { json: data, ...options }).json();
};
var updatePage = (client, provider) => async (id, data, options) => {
  return await client.patch(`${provider}/pages/${id}`, { json: data, ...options }).json();
};
var deletePage = (client, provider) => async (id, options) => {
  await client.delete(`${provider}/pages/${id}`, options);
};
var getPages = (client, provider) => async (options) => {
  return await client.get(`${provider}/pages`, options).json();
};
var addPageComponent = (client, provider) => async (id, componentId, index, options) => {
  return await client.post(`${provider}/pages/${id}/components/${componentId}`, { json: { index }, ...options }).json();
};
var removePageComponent = (client, provider) => async (id, componentId, options) => {
  return await client.delete(`${provider}/pages/${id}/components/${componentId}`, options).json();
};
var getPageByCategory = (client, provider) => async (categoryId, options) => {
  return await client.get(`${provider}/pages/categories/${categoryId}`, options).json();
};
var getPageByTag = (client, provider) => async (tagId, options) => {
  return await client.get(`${provider}/pages/tags/${tagId}`, options).json();
};
var getPageByStory = (client, provider) => async (storyId, options) => {
  return await client.get(`${provider}/pages/stories/${storyId}`, options).json();
};
var getPageBySlug = (client, provider) => async (slug, options) => {
  return await client.get(`${provider}/pages/custom/${slug}`, options).json();
};
var createPageApi = (client, provider) => {
  return {
    getPage: getPage(client, provider),
    createPage: createPage(client, provider),
    updatePage: updatePage(client, provider),
    deletePage: deletePage(client, provider),
    getPages: getPages(client, provider),
    addPageComponent: addPageComponent(client, provider),
    removePageComponent: removePageComponent(client, provider),
    getPageByCategory: getPageByCategory(client, provider),
    getPageByTag: getPageByTag(client, provider),
    getPageByStory: getPageByStory(client, provider),
    getPageBySlug: getPageBySlug(client, provider)
  };
};

// src/common.ts
var Provider = /* @__PURE__ */ ((Provider2) => {
  Provider2["VGTV"] = "vgtv";
  Provider2["AB"] = "ab";
  return Provider2;
})(Provider || {});
var Newsroom = /* @__PURE__ */ ((Newsroom2) => {
  Newsroom2["VG"] = "vg";
  Newsroom2["AB"] = "ab";
  return Newsroom2;
})(Newsroom || {});

// src/index.ts
var createApi = (client, provider) => {
  return {
    component: createComponentApi(client, provider),
    editor: createEditorApi(client, provider),
    user: createUserApi(client),
    image: createImageApi(client, provider),
    story: createStoryApi(client, provider),
    tag: createTagApi(client, provider),
    page: createPageApi(client, provider)
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Newsroom,
  Provider,
  createApi
});
